export default __webpack_public_path__ + "static/media/assassin_white_icon.25b794fc.png";